import { defineComponent } from "vue"

export default defineComponent({
  props: ["name", "title"] as const,
  render() {
    return (
      <i
        class={`icon icon-${this.name}`}
        title={this.title}
      />
    )
  },
})
